<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-row justify="center" align="center">
        <DialogLinkCompany ref="dlgLink" @save="onLinkCompany"></DialogLinkCompany>
        <DialogLinkPlaylist ref="dlgLinkPL" @save="onLinkPL"></DialogLinkPlaylist>
        <v-col cols="12" md="12" class="pt-0" v-if="false">
            <v-card flat>
                <v-card-title>
                    Media Items
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Suche"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
            </v-card>
        </v-col>
        <v-col cols="12">
            <v-row justify="start">
                <v-card v-for="item in deviceList"
                        v-bind:key="item.id"
                        max-width="350"
                        class="ma-2"
                >
                    <v-img :src="tableUtils.getImage(item)" :lazy-src="tableUtils.getImageThumbUrl(item)" contain alt="Thumbnail"
                           max-height="197">
                        <v-col cols="12" sm="4" class="pt-0 pl-0">
                            <v-card max-height="30" color="rgb(255, 255, 255, 0.7)" tile flat>
                                <v-checkbox label="Aktiv" v-model="item.active" @change="changeActive(item)"
                                            class="mt-0"
                                            :readonly="item.readOnly"
                                            color="red"></v-checkbox>
                            </v-card>
                        </v-col>
                        <v-row align="end" class="lightbox fill-height" style="margin-top: -42px">
                            <v-col class="py-0">
                                <v-card class="pl-1 caption" tile color="rgb(255, 255, 255, 0.5)">
                                    {{item.id}}. <span class="handle handpointer" @click="editItem(item)">{{item.name}}</span>
                                    <br>
                                    <span class="handle handpointer" v-if="item.fromPlayList" style="margin-left: 24px;" :style="getColor(item)">(aus {{item.fromPlayList}})</span>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-img>
                    <v-list>
                        <v-list-item>
                            <v-row>
                                <v-list-item-content class="pb-0">
                                    <v-col col="12" sm="6" class="pb-0">
                                        <v-text-field dense outlined v-model="item.orderNr"
                                                      @change="setOrderNr(item)" label="Sort"
                                                      prepend-icon="format_line_spacing"></v-text-field>
                                    </v-col>
                                    <v-col col="12" sm="6" class="pb-0"
                                           v-if="!(item.type === 'WEB' || item.type === 'PLAYLIST')">
                                        <v-text-field dense outlined label="Dateigröße" prepend-icon="crop"
                                                      :value="toMB(item.size)" readonly>
                                        </v-text-field>
                                    </v-col>
                                </v-list-item-content>
                            </v-row>
                        </v-list-item>
                        <v-list-item>
                            <v-row>
                                <v-list-item-content class="pb-0">
                                    <v-col col="12" sm="12" class="pb-0">
                                        <v-text-field dense outlined @change="setDuration(item)" v-model="item.duration"
                                                      label="Spielzeit in Sekunden" prepend-icon="timelapse"></v-text-field>
                                    </v-col>
                                </v-list-item-content>
                            </v-row>
                        </v-list-item>

                        <v-list-item v-if="item.type === 'WEB'">
                            <v-row>
                                <v-list-item-content class="pb-0">
                                    <v-col col="12" sm="12" class="pb-0">
                                        <v-text-field dense outlined @change="setFileName(item)"
                                                      v-model="item.localFileName" label="Webseite"
                                                      prepend-icon="web"></v-text-field>
                                    </v-col>
                                </v-list-item-content>
                            </v-row>
                        </v-list-item>


                        <!--<v-list-item>
                            <v-row>
                          <v-list-item-content class="pb-0">
                              <v-col col="12" sm="6" class="pb-0">
                                  <v-datetime-picker :textFieldProps="dtpProps" label="Sichtbar von" @input="setFrom(item)" v-model="item.formattedDatetime" date-format="dd.MM.yyyy" timeFormat="HH:mm"></v-datetime-picker>
                              </v-col>
                              <v-col col="12" sm="6" class="pb-0">
                                  <v-datetime-picker :textFieldProps="dtpProps1" label="Sichtbar bis" @input="setTill(item)" v-model="item.formattedDatetimeTill" date-format="dd.MM.yyyy" timeFormat="HH:mm"></v-datetime-picker>
                              </v-col>
                          </v-list-item-content>
                            </v-row>
                        </v-list-item>-->

                        <v-list-item>
                            <v-list-item-content :class="getTimeClass(item)">
                                <v-datetime-picker :textFieldProps="dtpProps" label="Sichtbar von"
                                                   @input="setFrom(item)"
                                                   v-model="item.formattedDatetime" date-format="dd.MM.yyyy"
                                                   timeFormat="HH:mm"></v-datetime-picker>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-content :class="getTimeClass(item)">
                                <v-datetime-picker :textFieldProps="dtpProps1" label="Sichtbar bis"
                                                   @input="setTill(item)"
                                                   v-model="item.formattedDatetimeTill" date-format="dd.MM.yyyy"
                                                   timeFormat="HH:mm"></v-datetime-picker>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-row justify="space-between" class="px-2">
                                <v-btn class="ma-2 text-none" small icon text color="red"
                                       @click="deleteItem(item)"
                                       v-if="!item.readOnly">
                                    <v-icon>
                                        delete
                                    </v-icon>
                                </v-btn>
                                <v-btn class="ma-2 text-none" small icon text color="black"
                                       @click="editItem(item)"
                                       v-if="!item.readOnly">
                                    <v-icon>
                                        edit
                                    </v-icon>
                                </v-btn>
                            </v-row>
                        </v-list-item>
                    </v-list>
                </v-card>
                <v-hover
                        v-slot:default="{ hover }"
                        open-delay="200"
                >
                    <v-card
                            :elevation="hover ? 16 : 2"
                            min-width="350"
                            max-width="350"
                            min-height="350"
                            max-height="350"
                            class="ma-2 handpointer"
                    >
                        <v-expand-transition>
                            <div
                                    v-if="hover"
                                    class="d-flex transition-fast-in-fast-out red accent-4 v-card--reveal display-3 white--text"
                                    style="height: 100%;"
                            >
                                <div class="uploadimage">
                                    <v-col cols="12">
                                        <div id="drag-and-drop-zone" class="uploader">
                                            <div class="browser">
                                                <label>
                                                    <v-row justify="center" class="mt-5">
                                                        <label>
                                                            <!--<input type="hidden" name="guid" :value="uploadGuid">-->
                                                            <v-col cols="12">
                                                                <v-row justify="center">
                                                                    <v-icon color="white" large>
                                                                        cloud_upload
                                                                    </v-icon>
                                                                    <v-card-text
                                                                            class="text-center subtitle-1 font-weight-bold">
                                                                        Datei hochladen oder <br>einfach hierherziehen
                                                                    </v-card-text>

                                                                </v-row>
                                                            </v-col>
                                                            <v-col cols="12">
                                                                <v-row justify="center">
                                                                <span class="ButtonWhiteUpload">
                                                                    <v-btn class="text-none" outlined @click="pickFile">Datei auswählen</v-btn>
                                                                </span>
                                                                </v-row>
                                                            </v-col>
                                                        </label>
                                                    </v-row>

                                                </label>
                                            </div>
                                        </div>

                                    </v-col>
                                </div>
                            </div>
                        </v-expand-transition>

                        <v-col cols="12" class="mt-10">
                            <v-card-title class="bigicon">
                                <v-spacer></v-spacer>
                                <v-icon color="red accent-4">add_circle</v-icon>
                                <v-spacer></v-spacer>
                            </v-card-title>
                            <v-card-title>
                                <v-spacer></v-spacer>
                                Datei zur Playlist hinzufügen
                                <v-spacer></v-spacer>
                            </v-card-title>
                        </v-col>

                    </v-card>
                </v-hover>
            </v-row>
        </v-col>

        <v-container fluid>
            <v-row>
                <v-col cols="12" class="mt-n6 mb-9">
                    <v-row justify="center">
                        <v-spacer></v-spacer>
                        <v-btn @click="addPlayList" small class="text-none" outlined color="indigo darken-4">Playlist
                            hinzufügen
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn @click="addURLItem" small class="text-none" outlined color="indigo darken-4">WEB Item
                            hinzufügen
                        </v-btn>
                        <v-spacer></v-spacer>
                        <!--
                        <v-btn @click="savePlayListSort" v-if="sortChanged" class="pl-2">Sortierung speichern</v-btn>
                        -->
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </v-row>
</template>

<script>
    import Vue from 'vue'
    import Sortable from 'sortablejs'
    import DialogLinkCompany from './../module/dialogs/DialogLinkCompany'
    import DialogLinkPlaylist from './../module/dialogs/DialogLinkPlaylist'

    // import draggable from 'vuedraggable'
    var _ = require('lodash')
    var moment = require('moment');
    export default {
        name: 'TablePlayListItems',
        components: {DialogLinkCompany, DialogLinkPlaylist},
        methods: {
            pickFile: function () {
                this.$emit('startUpload')
            },
            startUpload: function () {
                this.$emit('startUpload')
            },
            openCompanyDialog: function (item) {
                console.log('openCompanyDialog', item)
                this.currentDevice = item
                this.$refs.dlgLink.open({
                    title: 'Netzwerk zuweisen',
                    description: 'Wählen Sie ein Netzwerk'
                })
            },
            setDT(a) {
                var d = new Date(a)
                console.log(d.getTime())
            },
            getTimeClass (item) {
                var d1 = new Date(item.activeFrom)
                var d2 = new Date(item.activeTill)
                var d3 = new Date()
                var a = d3.getTime() >= d1.getTime()
                var b = d3.getTime() <= d2.getTime()
                if (a && b){
                    return 'pb-0 greenInput'
                } else {
                    return 'pb-0 redInput'
                }
            },
            setFrom(item) {
                item.activeFrom = new Date(item.formattedDatetime).getTime()
                console.log(item)
                Vue.prototype.$api.updatePlayListItem(item.guid, item, this.onItemUpdated)
            },
            setFileName(item) {
                Vue.prototype.$api.updatePlayListItem(item.guid, item, this.onItemUpdated)
            },
            setDuration(item) {
                Vue.prototype.$api.updatePlayListItem(item.guid, item, this.onItemUpdated)
            },
            setTill(item) {
                item.activeTill = new Date(item.formattedDatetimeTill).getTime()
                Vue.prototype.$api.updatePlayListItem(item.guid, item, this.onItemUpdated)
            },
            onItemUpdated: function () {
                this.reload(this.playListGuid)
            },
            onLinkCompany: function (item) {
                console.log('onLinkCompany', item)
                Vue.prototype.$api.linkPlayListToCompany(this.currentDevice, item, this.onItemUpdated)
            },
            onLinkPL: function (item) {
                console.log('onLinkPL', item)
                var cmp = this
                Vue.prototype.$api.linkPlayListToPlayList(this.playListGuid, item, function () {
                    cmp.reload(cmp.playListGuid)
                })
            },
            getColor: function (item) {
                var css = ''
                var cpl = '#ee0d10'
                if (item.fromPlayList) {
                    css += 'color:' + cpl + ';'
                }
                if (item.type === 'PLAYLIST') {
                    css += 'color:' + cpl + '; font-weight: bold;'
                }
                return css;
            },
            deleteItem: function (item) {
                var cmp = this
                Vue.prototype.$api.deletePlaylistItem(this.playListGuid, item.guid, function () {
                    cmp.reload(cmp.playListGuid)
                })
            },
            editItem: function (item) {
                this.$router.push('/PlaylistItem/' + item.guid)
            },
            addPlayList: function () {
                this.$refs.dlgLinkPL.open()
            },
            addURLItem: function () {
                var newItem = {
                    orderNr: 900,
                    name: 'Web URL',
                    localFileName: 'https://kermax.tv/',
                    localAbsoluteFileName: '',
                    type: 'WEB',
                    mime: 'web',
                    size: 0,
                    duration: 10,
                    md5: '',
                    config: '',
                    thumb: '',
                    active: 0
                }
                console.log('addURLItem', this.playListGuid, newItem)
                var cmp = this
                Vue.prototype.$api.createPlaylistItem(this.playListGuid, newItem, function (data) {
                    console.log('data', data)
                    cmp.reload(cmp.playListGuid)
                })
            },
            savePlayListSort: function () {
                console.log('savePlayListSort', this.deviceList)
                var idList = []
                for (var i in this.deviceList) {
                    var item = this.deviceList[i]
                    idList.push(item.id)
                }
                var r = {
                    sort: JSON.stringify(idList)
                }
                console.log('savePlayListSort', r)
                Vue.prototype.$api.savePlayListSort(this.playListGuid, r, this.onPlayListSortSaved)
            },
            onPlayListSortSaved: function (res) {
                console.log('onPlayListSortSaved', res)
            },
            getCompanyStyle: function (item) {
                var style = ''
                if (!item.company) {
                    style = 'color: #aa4444;'
                }
                return style
            },
            toMB: function (bytes, decimals) {
                if (bytes == 0) return '0 Bytes';
                var k = 1024,
                    dm = decimals <= 0 ? 0 : decimals || 2,
                    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                    i = Math.floor(Math.log(bytes) / Math.log(k));
                return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            },
            reload: function (guid) {
                this.playListGuid = guid
                Vue.prototype.$api.loadPlayListItems(this.playListGuid, this.onGetData)
            },
            onGetData: function (result) {
                console.log('result', result)
                this.deviceList = result
                this.sortArray = _.clone(this.deviceList)
                // this.activateDragAndDrop()

                this.updateCounter()
            },
            updateCounter() {
                var listData = {
                    cnt: 1,
                    duration: 0,
                    size: 0
                }
                for (var index in this.deviceList) {
                    var row = this.deviceList[index]
                    row.formattedDatetime = moment(row.activeFrom).format("DD.MM.YYYY HH:mm")
                    row.formattedDatetimeTill = moment(row.activeTill).format("DD.MM.YYYY HH:mm")
                    console.log('row', row)
                    if (row.active) {
                        listData.duration = listData.duration + row.duration * 1
                    }
                    listData.size = listData.size + row.size
                }
                console.log('listData.duration', listData.duration)
                listData.cnt = this.deviceList.length
                this.$emit('getCount', listData)
            },
            convertToDateTime: function (t) {
                return moment(t).format("DD.MM.YYYY HH:mm")
            },
            onDragEnd: function (evt) {
                var newIndex = evt.newIndex
                var oldIndex = evt.oldIndex
                console.log('', newIndex, oldIndex, this, this.deviceList[0].id)
                while (oldIndex < 0) {
                    oldIndex += this.deviceList.length
                }
                while (newIndex < 0) {
                    newIndex += this.deviceList.length
                }
                if (newIndex >= this.deviceList.length) {
                    let k = newIndex - this.deviceList.length
                    while ((k--) + 1) {
                        this.items.push(undefined)
                    }
                }
                this.deviceList.splice(newIndex, 0, this.deviceList.splice(oldIndex, 1)[0])
                this.sortChanged = true

                var iii = 100
                for (var i in this.deviceList) {
                    this.deviceList[i].orderNr = (iii + 1) * 100
                    iii++
                }
                console.log('', newIndex, oldIndex, this.deviceList)
            },
            setOrderNr(item) {
                var cmp = this
                console.log('setOrderNr', item)
                Vue.prototype.$api.updatePlayListItem(item.guid, item, function () {
                    cmp.reload(cmp.playListGuid)
                })
            },
            changeActive(item) {
                if (item.active === 0) item.active = 1
                if (item.active === 1) item.active = 0
                if (item.readOnly) {
                    return
                }
                var cmp = this
                Vue.prototype.$api.updatePlayListItem(item.guid, item, function () {
                    cmp.reload(cmp.playListGuid)
                    cmp.updateCounter()
                })
            },
            activateDragAndDrop() {
                // window.jQuery(".plTable .v-data-table tbody")
                let table = document.querySelector('.plTable .v-data-table tbody')
                const _self = this
                console.log('activateDragAndDrop', table)
                Sortable.create(table, {
                    handle: '.handle',
                    onEnd: _self.onDragEnd
                })
            }
        },
        data() {
            return {
                dtpProps: {
                    dense: true,
                    outlined: true,
                    'prepend-icon': 'update',
                },
                dtpProps1: {
                    dense: true,
                    outlined: true,
                    'prepend-icon': 'update',
                },
                currentDevice: null,
                tableUtils: require('./TableUtils').default,
                search: null,
                sortChanged: false,
                sortArray: [],
                colors: ['red', 'blue'],
                colorMap: [],
                headers: [
                    {text: 'Sort', value: 'orderNr', width: 80},
                    {text: 'Aktiv', value: 'active'},
                    {text: 'Icon', value: 'thumb'},
                    {text: 'Name', align: 'left', value: 'name'},
                    {text: 'Sichtbar', value: 'activeFrom'},
                    /*{text: 'Erstellt', value: 'created'},*/
                    /*{text: 'Remote', value: 'remoteAddress'},*/
                    {text: 'Dateigröße', value: 'size'},
                    /*{text: 'Type', value: 'type'},*/
                    /*{text: 'Kommentar', value: 'comment'},*/
                    {text: 'Aktion', value: 'action'}
                ],
                deviceList: []
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>

</style>
